import { useMemo } from 'react';

import { scaleLinear, scaleTime } from '@visx/scale';

import { BalanceProjectionItem } from '../../../../graphql/schema';

type TimeSeries = BalanceProjectionItem[];
type Margin = { top: number; right: number; bottom: number; left: number };
type Props = { data: TimeSeries; target?: number | null; width: number; height: number; margin: Margin };

export const useChartScale = ({ data, target, width, height, margin }: Props) => {
  const xMax = Math.max(0, width - margin.left - margin.right);
  const yMax = Math.max(0, height - margin.top - margin.bottom);

  const xScale = useMemo(() => {
    const times = data.map(d => d.date.getTime());
    return scaleTime({ range: [0, xMax], domain: [times[0], times[times.length - 1]] });
  }, [xMax, data]);

  const yScale = useMemo(() => {
    const optimistic = data.map(d => d.optimistic.cents);
    const maximum = Math.max(...(target ? [target, ...optimistic] : optimistic));
    return scaleLinear({ range: [yMax, 0], domain: [0, maximum], nice: true });
  }, [yMax, data]);

  return { xScale, xMax, yScale, yMax };
};
